import { useEffect, useState } from "react";
import { CommonService } from "../../../services/CommonService";
import { useAdvanceSearchContext } from "./AdvanceSearchContext";
import { DropDownMultiCheck } from "./DropDownMultiCheck";

export default function ManagerInterest() {
  const { searchObject,setSearchObject, t } = useAdvanceSearchContext();
  const [interestTypes, setInterestTypes] = useState([]);

  useEffect(
    () =>
      CommonService.getInterestType().then((data) =>
        setInterestTypes(data)
      ),
    []
  );
  function setSelectedManagerInterest(list) { 

    setSearchObject({ ...searchObject, managerInterestId: list });
  }
  return (
    <>
    <fieldset>
      <legend>{t("Manager Interest")}</legend>
      {/* <select
        name="managerInterestId"
        onChange={onChange}
        value={searchObject.managerInterestId || ""}
        className="form-select"
      >
        <option value=""></option>
        {interestTypes.map((interest) => (
          <option key={interest.id} value={interest.id}>
            {t(interest.description)}
          </option>
        ))}
      </select> */}
        <DropDownMultiCheck
        dataList={interestTypes}
        selecteds={searchObject.managerInterestId}
        setSelecteds={setSelectedManagerInterest}
      />
    </fieldset>
    </>
  );
}
